"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var capabilitiesSymbol = Symbol('capabilities');
var displayNameSymbol = Symbol('displayName');
var idSymbol = Symbol('id');
var metaSymbol = Symbol('meta');
var typeSymbol = Symbol('type');
var orderSymbol = Symbol('order');

var Card = /*#__PURE__*/function () {
  function Card(_ref) {
    var _ref$capabilities = _ref.capabilities,
        capabilities = _ref$capabilities === void 0 ? {} : _ref$capabilities,
        _ref$displayName = _ref.displayName,
        displayName = _ref$displayName === void 0 ? null : _ref$displayName,
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? null : _ref$id,
        _ref$meta = _ref.meta,
        meta = _ref$meta === void 0 ? null : _ref$meta,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? '' : _ref$type,
        _ref$order = _ref.order,
        order = _ref$order === void 0 ? null : _ref$order;
    (0, _classCallCheck2.default)(this, Card);
    this[capabilitiesSymbol] = capabilities;
    this[displayNameSymbol] = displayName;
    this[idSymbol] = id;
    this[metaSymbol] = meta;
    this[typeSymbol] = type;
    this[orderSymbol] = order;
  }

  (0, _createClass2.default)(Card, [{
    key: "capabilities",
    get: function get() {
      return this[capabilitiesSymbol];
    },
    set: function set(capabilities) {
      this[capabilitiesSymbol] = capabilities;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this[displayNameSymbol];
    },
    set: function set(displayName) {
      this[displayNameSymbol] = displayName;
    }
  }, {
    key: "id",
    get: function get() {
      return this[idSymbol];
    },
    set: function set(id) {
      this[idSymbol] = id;
    }
  }, {
    key: "meta",
    get: function get() {
      return this[metaSymbol];
    },
    set: function set(meta) {
      this[metaSymbol] = meta;
    }
  }, {
    key: "type",
    get: function get() {
      return this[typeSymbol];
    },
    set: function set(type) {
      this[typeSymbol] = type;
    }
  }, {
    key: "order",
    get: function get() {
      return this[orderSymbol];
    },
    set: function set(order) {
      this[orderSymbol] = order;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        capabilities: this[capabilitiesSymbol],
        displayName: this[displayNameSymbol],
        id: this[idSymbol],
        meta: this[metaSymbol],
        type: this[typeSymbol],
        order: this[orderSymbol]
      };
    }
  }]);
  return Card;
}();

exports.default = Card;
module.exports = exports.default;